import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useContext, useMemo, useState } from 'react';
var initialActiveTriggerState = {
  activeTriggerState: {
    activeTriggerId: undefined
  }
};
var initialTriggerDispatchState = {
  setTriggerState: function setTriggerState() {
    // eslint-disable-next-line no-console
    console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
  }
};
var TriggerContext = /*#__PURE__*/React.createContext(initialActiveTriggerState);
var TriggerDispatchContext = /*#__PURE__*/React.createContext(initialTriggerDispatchState);
export var TriggerContextProvider = function TriggerContextProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(initialActiveTriggerState.activeTriggerState),
    _useState2 = _slicedToArray(_useState, 2),
    activeTriggerState = _useState2[0],
    setActiveTriggerState = _useState2[1];
  var setTriggerState = useCallback(function (_ref2) {
    var isActive = _ref2.isActive,
      triggerId = _ref2.triggerId;
    setActiveTriggerState(function (current) {
      var hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
      if (!hasStateChanged) {
        return current;
      }
      if (isActive) {
        return {
          activeTriggerId: triggerId
        };
      }
      return {
        activeTriggerId: undefined
      };
    });
  }, []);
  var triggerContextValue = useMemo(function () {
    return {
      activeTriggerState: activeTriggerState
    };
  }, [activeTriggerState]);
  var triggerContexDispatchValue = useMemo(function () {
    return {
      setTriggerState: setTriggerState
    };
  }, [setTriggerState]);
  return /*#__PURE__*/React.createElement(TriggerContext.Provider, {
    value: triggerContextValue
  }, /*#__PURE__*/React.createElement(TriggerDispatchContext.Provider, {
    value: triggerContexDispatchValue
  }, children));
};

// Public Hooks

// For use in dev tools
export var useTriggerContext = function useTriggerContext() {
  return useContext(TriggerContext);
};
export var useTriggerDispatchContext = function useTriggerDispatchContext() {
  return useContext(TriggerDispatchContext);
};

// For use in messages
export var useTrigger = function useTrigger(triggerId) {
  var _useTriggerContext = useTriggerContext(),
    activeTriggerState = _useTriggerContext.activeTriggerState;
  return triggerId ? {
    isActive: activeTriggerState.activeTriggerId === triggerId
  } : {
    isActive: undefined
  };
};

// For use externally
export var useFirePostOfficeTrigger = function useFirePostOfficeTrigger(_ref3) {
  var triggerId = _ref3.triggerId;
  var _useTriggerDispatchCo = useTriggerDispatchContext(),
    setContextTriggerState = _useTriggerDispatchCo.setTriggerState;
  var fireTrigger = useCallback(function (_ref4) {
    var isActive = _ref4.isActive;
    return setContextTriggerState({
      triggerId: triggerId,
      isActive: isActive
    });
  }, [setContextTriggerState, triggerId]);
  return {
    fireTrigger: fireTrigger
  };
};